"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uniqueId;

var _mathRandom = _interopRequireDefault(require("math-random"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This format ID must be compatible with HTML "className" and "id" attribute.
// It will be suffixed as "webchat__activity--{id}".
function uniqueId() {
  // eslint-disable-next-line no-magic-numbers
  return (0, _mathRandom.default)().toString(36).substring(2, 7);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1bmlxdWVJZCIsInJhbmRvbSIsInRvU3RyaW5nIiwic3Vic3RyaW5nIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHJvdmlkZXJzL0FjdGl2aXR5S2V5ZXIvcHJpdmF0ZS91bmlxdWVJZC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgcmFuZG9tIGZyb20gJ21hdGgtcmFuZG9tJztcblxuLy8gVGhpcyBmb3JtYXQgSUQgbXVzdCBiZSBjb21wYXRpYmxlIHdpdGggSFRNTCBcImNsYXNzTmFtZVwiIGFuZCBcImlkXCIgYXR0cmlidXRlLlxuLy8gSXQgd2lsbCBiZSBzdWZmaXhlZCBhcyBcIndlYmNoYXRfX2FjdGl2aXR5LS17aWR9XCIuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1bmlxdWVJZCgpOiBzdHJpbmcge1xuICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgbm8tbWFnaWMtbnVtYmVyc1xuICByZXR1cm4gcmFuZG9tKCkudG9TdHJpbmcoMzYpLnN1YnN0cmluZygyLCA3KTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRUE7QUFDQTtBQUNlLFNBQVNBLFFBQVQsR0FBNEI7RUFDekM7RUFDQSxPQUFPLElBQUFDLG1CQUFBLElBQVNDLFFBQVQsQ0FBa0IsRUFBbEIsRUFBc0JDLFNBQXRCLENBQWdDLENBQWhDLEVBQW1DLENBQW5DLENBQVA7QUFDRCJ9